import { useEffect, useState } from "react"
import { X, Upload } from "lucide-react"
import { useCloud } from "../hooks/useCloud"
import toast from "react-hot-toast"

export function AddCategoryForm({ categoryItem, onClose, onSubmit }) {
    const { uploadCategoryImage } = useCloud()
    const [name, setName] = useState("")
    const [imageURL, setImageURL] = useState("")
    const [rank, setRank] = useState(null)
    const [imagePreview, setImagePreview] = useState(null)

    useEffect(() => {
        if(categoryItem)
        {
            setName(categoryItem.categoryName)
            setImageURL(categoryItem.categoryImage)
            setRank(categoryItem.categoryRank)
            
            // Handle image preview
            if (categoryItem.categoryImage) {
                setImagePreview(categoryItem.categoryImage)
            }
        }
    }, [categoryItem])

    const handleImageUpload = async (e) => {
        const file = e.target.files[0]
        if (!file) return

        try {
            // Show loading state
            const loadingToast = toast.loading("Uploading image...")

            const response = await uploadCategoryImage(
                categoryItem?.categoryId || "temp",
                file
            )

            if (response.success) {
                setImagePreview(response.data.imageUrl)
                setImageURL(response.data.imageUrl)
                toast.success("Image uploaded successfully", { id: loadingToast })
            } else {
                toast.error(response.message || "Failed to upload image", {
                    id: loadingToast,
                })
            }
        } catch (error) {
            toast.error("Error uploading image")
            console.error("Image upload error:", error)
        }
    }

    const handleImageDelete = async (e) => {
        e.stopPropagation()

        setImagePreview(null)
        setImageURL("")

        toast.success("Image removed successfully")
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        onSubmit({
            "categoryName": name,
            "categoryImage": imageURL,
            "status": "active",
            "rank": rank
        })
    }

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" style={{zIndex:501}}>
            <div className="bg-white rounded-lg shadow-lg w-full max-w-md">
                <div className="flex items-center justify-between p-4 border-b">
                    <h2 className="text-lg font-semibold">Add New Category</h2>
                    <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
                        <X className="w-5 h-5" />
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="p-4">
                    <div className="space-y-2">
                        <div className="space-y-2">
                            <label className="block text-sm font-medium text-gray-700">
                                Category Image
                            </label>
                            <div
                                className="border-2 border-dashed rounded-xl p-6 flex flex-col items-center justify-center cursor-pointer hover:border-blue-400 border-gray-300 bg-gray-50 transition-all duration-200"
                                onClick={() => {
                                    document.getElementById("category-image-upload").click();
                                }}
                            >
                                {imagePreview ? (
                                    <div className="relative w-full">
                                        <img
                                            src={imagePreview}
                                            alt="Category preview"
                                            className="w-full h-40 object-contain"
                                            crossOrigin="anonymous"
                                            loading="lazy"
                                        />
                                        <button
                                            type="button"
                                            className="absolute -top-2 -right-2 bg-white text-gray-600 p-1 rounded-full hover:bg-gray-100 shadow-sm transition-all duration-200"
                                            onClick={async (e) => handleImageDelete(e)}
                                        >
                                            <X className="w-4 h-4" />
                                        </button>
                                    </div>
                                ) : (
                                    <>
                                        <Upload className="w-6 h-6 mb-2 text-gray-400" />
                                        <p className="text-sm text-gray-500">
                                            Click to upload category image
                                        </p>
                                        <p className="mt-1 text-xs text-gray-400">
                                            PNG, JPG, GIF up to 5MB
                                        </p>
                                    </>
                                )}
                                <input
                                    id="category-image-upload"
                                    type="file"
                                    accept="image/*"
                                    className="hidden"
                                    onChange={handleImageUpload}
                                />
                            </div>
                        </div>
                        <div className="space-y-2">
                            <label htmlFor="categoryName" className="block text-sm font-medium text-gray-700">
                                Category Name*
                            </label>
                            <input
                                id="categoryName"
                                type="text"
                                required
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md"
                            />
                        </div>
                    </div>

                    <div className="mt-6 flex justify-end space-x-3">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 bg-green-600 rounded-md text-sm font-medium text-white hover:bg-blue-700"
                        >
                            {categoryItem ? 'Update Category' : 'Add Category' } 
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}

